// import React, { useContext, useEffect, useState } from 'react'
import React, { useContext, useEffect, useState } from 'react'
// import { Clipboard2PlusFill } from 'react-bootstrap-icons'
// import { useLocation } from 'react-router-dom'
// import Authentication from '../../../../libs/api/services/Authentication'
// import ToDoListWorkFlows from '../../../../libs/api/services/ToDoListWorkFlows'
// import { ClaimsFilter } from '../../../../libs/authentication/ClaimsFilter'
// import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
// import ToDoListContext from '../ToDoListProvider'
// import ToDoListGroupContainer from './Groups/ToDoListGroupContainer'
import { Clipboard2PlusFill } from 'react-bootstrap-icons'
import { ICONS } from '../../../../components/icons/GenericIconPicker'
import Authentication from '../../../../libs/api/services/Authentication'
import ToDoListWorkFlows from '../../../../libs/api/services/ToDoListWorkFlows'
import { ClaimsFilter } from '../../../../libs/authentication/ClaimsFilter'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import ToDoListContext, { ToDoListProvider } from '../ToDoListProvider'
import ToDoListLineItemPopup from './ToDoListLineItemPopup'
import StartNewToDoListWizard from './Wizards/StartNewToDoListWizard'

export default function ToDoListContainer() {
    const [mode, setMode] = useState()
    const { ToDoLists, LoadToDoLists, showError, loading } = useContext(ToDoListContext)
    const { setSectionInfo, setAssistantSection } = useContext(CommonFunctionsContext)

    const hasAccess = (list) => {
        for (const taskItems of list.taskItems) {
            for (const item of taskItems.taskItem.items)
                if (item.accessTypes.includes('View' || item.accessTypes.includes('Edit'))) return true
        }
        return false
    }
    const GroupAndDate = () =>
        ToDoLists.reduce((acc, red) => {
            if (hasAccess(red)) {
                var _acc = acc
                var _current = acc.find(a => a.taskGroup && a.taskGroup === red.taskGroup && a.assignedDate.substring(0, 10) === red.assignedDate.substring(0, 10))
                if (_current)
                    _current.taskItems = [..._current.taskItems, ...red.taskItems]
                else
                    _acc.push({ ...red, taskItems: red.taskItems })
                return _acc
            }
            return acc
        }, []).reduce((acc, red) => {
            // console.log(acc.find(a => a.date && a.date.substring(0, 10) === red.assignedDate.substring(0, 10)))
            const existing = acc.find(a => a.date && a.date.substring(0, 10) === red.assignedDate.substring(0, 10))
            // console.log(acc.assignedDate.substring(0, 10), red.assignedDate.substring(0, 10))
            if (existing) {
                existing.items = [...existing.items, red]
                // acc.items = [...acc.items, ...red]
            } else {
                acc = [...acc, {
                    date: red.assignedDate.substring(0, 10),
                    items: [red]
                }]
            }
            return acc
        }, [])

    useEffect(() => {
        // setAssistant({ ...OnScreenHelpItems['ToDoList'] });
        setAssistantSection('To Do List');
        setSectionInfo(`${JSON.parse(Authentication.UserName())} To Do List`)
        return () => { setSectionInfo(); }
    }, [])

    //     switch (mode) {
    //         case 'Start New': return <StartNewToDoListWizard onCancel={() => setMode()} onComplete={(props) => {
    //             // Populate User List
    //             var users = [{ user: { id: Authentication.UserId() } }]
    //             props.assisted.assisted && users.push({ user: { id: props.assisted.user } })
    //             // Send to API
    //             ToDoListWorkFlows
    //                 .StartToDoList({
    //                     listItemGroup: props.list,
    //                     toDoListAssignmentUsers: users
    //                 })
    //                 .then((r) => {
    //                     // Reload lists
    //                     LoadToDoLists()
    //                     setMode()
    //                 }).catch((e) => showError(e))

    //         }} />

    // loading && <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'>
    //     <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
    //     <b className='p-3'>Loading your to do lists</b>
    // </div>
    return (
        {
            "Start New": <StartNewToDoListWizard onCancel={() => setMode()} onComplete={(props) => {
                // Populate User List
                var users = [{ user: { id: Authentication.UserId() } }]
                props.assisted.assisted && users.push({ user: { id: props.assisted.user } })
                // Send to API
                ToDoListWorkFlows
                    .StartToDoList({
                        listItemGroup: props.list,
                        toDoListAssignmentUsers: users
                    })
                    .then((r) => {
                        // Reload lists
                        LoadToDoLists()
                        setMode()
                    }).catch(showError)
            }} />,
        }[mode] || <Layout setMode={setMode}>{GroupAndDate(ToDoLists).map(entry => <TodoDate entry={entry} />)}</Layout>
    )

}
//  export default function ToDoListContainer() {
//     const { setSectionInfo, setAssistantSection, helpRefs } = useContext(CommonFunctionsContext)
//     const { ToDoLists, LoadToDoLists, showError } = useContext(ToDoListContext)
//     const [mode, setMode] = useState()

//     const location = useLocation();


//     useEffect(() => {
//         if (location && location.state) {
//             if (location.state.section)
//                 setMode(location.state.section)
//         }
//     }, [location])

//     const hasAccess = (list) => {
//         // console.log('hasAccess', list)
//         for (const taskItems of list.taskItems) {
//             if (taskItems.taskItem.group.accessTypes.includes('View' || taskItems.taskItem.group.accessTypes.includes('Edit'))) return true
//             if (taskItems.taskItem.list.accessTypes.includes('View' || taskItems.taskItem.list.accessTypes.includes('Edit'))) return true
//             for (const item of taskItems.taskItem.items)
//                 if (item.accessTypes.includes('View' || item.accessTypes.includes('Edit'))) return true
//         }
//         return false
//     }

//     const GroupDate = () => {
//         var res = []
//         if (ToDoLists)
//             for (const l of ToDoLists) {
//                 if (!hasAccess(l)) continue;
//                 var x = res.find(a => a.date === l.assignedDate.substring(0, 10))
//                 if (x)
//                     x.items.push(l)
//                 else
//                     res.push({
//                         date: l.assignedDate.substring(0, 10),
//                         items: [l]
//                     })
//             }
//         return res
//     }


//     switch (mode) {
//         case 'Start New': return <StartNewToDoListWizard onCancel={() => setMode()} onComplete={(props) => {
//             // Populate User List
//             var users = [{ user: { id: Authentication.UserId() } }]
//             props.assisted.assisted && users.push({ user: { id: props.assisted.user } })
//             // Send to API
//             ToDoListWorkFlows
//                 .StartToDoList({
//                     listItemGroup: props.list,
//                     toDoListAssignmentUsers: users
//                 })
//                 .then((r) => {
//                     // Reload lists
//                     LoadToDoLists()
//                     setMode()
//                 }).catch((e) => showError(e))

//         }} />
//         default: return (
//             <div className='d-flex flex-column mh-100'>
//                 {
//                     Authentication.getFacilityRole() === 'Patient'
//                         ?
//                         <></>
//                         :
//                         <ClaimsFilter resources={[{ resource: "To Do Lists", type: 'Edit' }, { resource: "To Do Lists", type: 'Inherit' }]} claim={[]}>
//                             <div className='bg-primary-container p-3'>
//                                 <button
//                                     ref={helpRefs.current["ToDoListCreateNewButton"] ??= { current: null }}
//                                     onClick={() => setMode('Start New')} className='btn'><Clipboard2PlusFill /> Start New List</button>
//                             </div>
//                         </ClaimsFilter>
//                 }
//                 <div ref={helpRefs.current["ToDoListSelection"] ??= { current: null }} className='flex-grow-1' style={{ overflow: 'auto' }}>
//                     {GroupDate().map((t, x) => <>
//                         <div key={`DateLI-${x}`} className='text-center opacity-50 m-2'>
//                             <h2>{t.date}</h2>
//                         </div>
//                         {t.items.map((i) => <ToDoListGroupContainer key={`GC-${Math.random() * 300}-${x}`} item={i} />)}
//                     </>)}
//                 </div>
//             </div>)
//     }

// }

const Layout = ({ setMode, children }) => {
    const { helpRefs } = useContext(CommonFunctionsContext)
    return (<>
        <ClaimsFilter resources={[{ resource: "To Do Lists", type: 'Edit' }, { resource: "To Do Lists", type: 'Inherit' }]} claim={[]}>
            <div className='bg-primary-container p-3'>
                <button
                    ref={helpRefs.current["ToDoListCreateNewButton"] ??= { current: null }}
                    onClick={() => setMode('Start New')} className='btn'><Clipboard2PlusFill /> Start New List</button>
            </div>
        </ClaimsFilter >
        <div style={{ overflow: 'auto' }}>{children}</div>
    </>
    )
}

const TodoDate = ({ entry }) => {
    return (<div key={`DateLI-${entry.date}`}>
        <div className='text-center opacity-50 m-2'>
            <h2>{entry.date}</h2>
        </div>
        {entry.items.map(group => <TodoGroup key={group.id} group={group} />)}
    </div>)
}
const TodoGroup = ({ group }) => {
    return (<div className='bg-white text-dark rounded shadow p-2'>
        {group.taskGroup}
        <div className='d-flex flex-column'>
            {group.taskItems && group.taskItems.map(item => <TodoLineItem key={item.status.id} item={item} />)}
        </div>
    </div>)
}
const TodoLineItem = ({ item }) => {
    // useEffect(() => { console.log('RENDER') }, [group])
    // console.log('TodoLineItem', item.status.id)
    const [properties, setProperties] = useState({
        colour: "",
        icons: []
    })
    useEffect(() => {
        let COLOR = ""
        let ICONS = []
        // const selected = item.taskItem.items.find(a => a.resource.isDefault).resource.id
        if (item) {
            try {
                const selected = (item.status.status ? item.status.status : item.taskItem.items.find(a => a.resource.isDefault).resource.item).id
                if (selected) {
                    const props =
                        item.taskItem.items.find(a => a.resource.id === selected).resource.properties
                    if (props) {
                        COLOR = props.find(a => a.property === "COLOUR")
                        COLOR = COLOR ? COLOR.value : ""
                        ICONS = props.find(a => a.property === "ICONS")
                        ICONS = ICONS && ICONS.value && Object.keys(ICONS).includes('value') ? JSON.parse(ICONS.value) : []
                    }
                }
            } catch { }
        }
        setProperties({
            colour: COLOR,
            icons: ICONS
        })
    }, [item])

    const { createModal } = useContext(CommonFunctionsContext)
    return (<div className={`d-flex align-items-center`}
        style={{ background: properties.colour ? properties.colour : 'transparent' }}
    >
        <div
            onClick={() => createModal(<ToDoListProvider>
                <ToDoListLineItemPopup defaultValues={null} assignmentId={item.status.assignment.id} item={item} />
            </ToDoListProvider>)}
            className='flex-grow-1 p-2'>
            {properties.icons && properties.icons.map(ico => ICONS.find(i => i.name === ico).icon)}
            {item.taskItem.list.resource.list}
        </div>
        <div>
            <TodoDropDown active={item.status} item={item} statuses={item.taskItem.items} />
        </div>
    </div>)
}
const TodoDropDown = ({ active, item, statuses }) => {
    const { SetStatus } = useContext(ToDoListContext)
    const [loading, isLoading] = useState(false)
    const handleChangeStatus = async (e) => {
        isLoading(true)
        await SetStatus(active.assignment.id, item.taskItem.list.resource, e.target.value);
        // await new Promise((resolve) => setTimeout(() => resolve(true), 1000))
        isLoading(false)
    }
    return loading ? <div>Updating Status</div> : statuses.filter(a => a.accessTypes.includes("Edit")).length > 0
        ?
        <select onChange={handleChangeStatus} className='form-control form-control-sm'>
            {statuses.map(status =>
                <option value={status.resource.id} selected={active && active.status && active.status.id === status.resource.id ? 'selected' : ((!(active && active.id)) && active.isDefault)} >{status.resource.item}</option>)
            }
        </select>
        :
        <div>{active.status ? active.status.item : statuses.find(a => a.resource.isDefault).resource.item}</div>

}